import { useMediaQuery } from 'usehooks-ts';

type Props = {
    largeDesktop?: number;
    desktop?: number;
    largeTablet?: number;
    tablet?: number;
    defaultCount: number;
};
export default function useSlidesPerView({
    largeDesktop,
    desktop,
    largeTablet,
    tablet,
    defaultCount = 1,
}: Props): number {
    const isTablet = useMediaQuery('(min-width: 768px)');
    const isLargeTablet = useMediaQuery('(min-width: 1024px)');
    const isDesktop = useMediaQuery('(min-width: 1200px) and (hover: hover)');
    const isLargeDesktop = useMediaQuery('(min-width: 1921px)');

    switch (true) {
        case isLargeDesktop && largeDesktop && typeof largeDesktop === 'number':
            return largeDesktop as number;
        case isDesktop && desktop && typeof desktop === 'number':
            return desktop as number;
        case isLargeTablet && largeTablet && typeof largeTablet === 'number':
            return largeTablet as number;
        case isTablet && tablet && typeof tablet === 'number':
            return tablet as number;
        default:
            return defaultCount;
    }
}
